<template>
  <div>
    <el-form-item label="筛选条件（无渲染）" prop="filter">
      <el-table
        :data="filter.condition">
        <el-table-column
          prop="name"
          label="条件名"
          width="120">
          <template scope="scope">
            <el-input class="w-100" v-model="scope.row.name" placeholder="请输入名称"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="field_id"
          label="关联关系数据表字段">
          <template scope="scope">
            <el-select
              v-model="scope.row.field_id">
              <el-option
                v-for="item in fields"
                :label="item.name + '(' + item.title + ')'"
                :value="item.field_id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="logic"
          label="逻辑">
          <template scope="scope">
            <el-select
              v-model="scope.row.logic">
              <el-option
                v-for="item in logicOption"
                :label="item.title"
                :value="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="value_type"
          label="值类型">
          <template scope="scope">
            <el-popover
              ref="popover1"
              placement="top-start"
              title="日期变量说明"
              width="200"
              trigger="hover"
              content="Y代表年，M代表月，D代表天，h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，h+1代表一个小时后，m+10代表十分钟后,s+30 代表30秒后"
              >
            </el-popover>
            <el-select
              clearable
              v-model="scope.row.value_type">
              <el-option
                v-for="item in typeOptions"
                :label="item.title"
                :value="item.id">
                <span v-if="item.id === 30" v-popover:popover1>{{ item.title }}</span>
                <span v-else>{{ item.title }}</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="value"
          label="值"
          width="120">
          <template scope="scope">
            <el-input class="w-100" v-model="scope.row.value" placeholder="请输入值" v-if="scope.row.value_type === 10"></el-input>
            <el-select
              v-model="scope.row.value"
              v-else-if="scope.row.value_type === 20">
              <el-option
                v-for="item in fields"
                :label="item.title"
                :value="item.name"></el-option>
            </el-select>
            <el-input class="w-100" v-model="scope.row.value" placeholder="请输入表达式" v-else-if="scope.row.value_type === 30"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template scope="scope">
            <el-button type="danger" size="small" @click="delConfig(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form-item>
    <div class="m-t-20 m-b-20">
      <el-button type="primary" @click="addConfig()">添加</el-button>
    </div>
    <el-form-item label="条件间逻辑关系" prop="filter.relation">
      <el-input
      class="w-300"
      type="textarea"
      :rows="3"
      placeholder="请输入逻辑关系表达式"
      v-model="filter.relation"></el-input>
      <el-button type="text" @click="checkValid">检查是否正确</el-button>
      <div class="form-tips">说明：为空则全部案件为AND关系，填写条件名和AND，OR以及括号，花括号（均为英文半角）来组合条件之间关系，慎重以免报错，若解析失败，则会以全部为AND来解析。填写例子：({条件名1} AND {条件名2}) OR ({条件名1} AND {条件名3})</div>
    </el-form-item>
  </div>
</template>

<script>
/**
 * props
 * @param [Array] filter 筛选条件列表 && 逻辑关系表达式
 * @param [Array] fields 关联的字段列表
 * @param [Array] rules 规则
 */
  export default {
    props: {
      filter: {},
      fields: {
        type: Array
      },
      rules: {}
    },
    data() {
      return {
        logicOption: [
          { id: 10, title: '等于' },
          { id: 20, title: '大于' },
          { id: 30, title: '小于' }
        ],
        typeOptions: [
          { id: 10, title: '常量' },
          { id: 20, title: '传参变量' },
          { id: 30, title: '时间变量' },
          { id: 40, title: '登录用户ID' }
        ],
        conditionShow: false
      }
    },
    created() {
      if (!this.filter.condition) {
        this.filter.condition = []
      }
      if (!this.filter.relation) {
        this.filter.relation = ''
      }
      this.setRules()
    },
    methods: {
      addConfig() { // 添加配置
        this.filter.condition.push({
          name: '',
          field_id: '',
          logic: '',
          value_type: '',
          value: null
        })
      },
      /**
       * 设置必填规则
       */
      setRules() {
        if (this.rules && this.rules.filter) {
          let validatePass = (rule, value, callback) => {
            if (value.condition && value.condition.length) {
              _(value.condition).forEach((item) => {
                if (!item.name) {
                  callback(new Error('条件名不能为空'))
                } else if (!item.field_id) {
                  callback(new Error('数据表字段不能为空'))
                } else if (!item.logic) {
                  callback(new Error('逻辑不能为空'))
                } else if (item.value === null) {
                  callback(new Error('值不能为空'))
                }
              })
              callback()
            }
          }
          this.rules.filter.push({
            validator: validatePass,
            trigger: 'change'
          })
          this.rules.filter.push({
            validator: validatePass,
            trigger: 'blur'
          })
        }
      },
      delConfig(index) { // 删除配置
        this.filter.condition.splice(index, 1)
      },
      /**
       * 检查表达式是否符合要求
       */
      checkValid() {
        if (!this.filter.relation || !this.filter.relation.length) {
          _g.toastMsg(this, 'warning', '表达式为空！')
          return
        }
        // 去掉空格
        let cleanFormula = this.filter.relation.replace(/\s/g, '')
        // 检测条件名是否用花括号包裹，以及括号是否为半角英文
        let result = cleanFormula.replace(/(AND)|(OR)|(\()|(\))|(\{.+?\})/g, '')
        if (result.length > 0) {
          if (result.indexOf('｛') >= 0 || result.indexOf('｝') >= 0) {
            _g.toastMsg(this, 'error', '请使用英文半角花括号！')
          } else if (result.indexOf('（') >= 0 || result.indexOf('）') >= 0) {
            _g.toastMsg(this, 'error', '请使用英文半角括号！')
          } else {
            _g.toastMsg(this, 'error', '请检查条件名是否用半角花括号包裹')
          }
          return
        }
        // 取出条件名检测是否存在
        let regexp = /\{.+?\}/g
        let conNames = cleanFormula.match(regexp)
        // 去掉表达式中的条件名只留下括号和逻辑名称
        let noNames = cleanFormula.replace(regexp, '')
        // 去掉匹配的结果中的花括号，只剩下条件名
        conNames = conNames.join('||').replace(/(\{)|(\})/g, '').split('||')
        // 检测是否有不存在的条件名
        let findUnknown = false
        let names = _.map(this.filter.condition, (item) => {
          return item.name
        })
        _(conNames).forEach((name) => {
          let findIndex = names.indexOf(name)
          if (findIndex < 0) {
            findUnknown = true
          }
        })
        if (findUnknown) {
          _g.toastMsg(this, 'error', '存在未知的条件名！')
          return
        }
        // 检测括号是否成对存在
        // 删除括号之外的字符
        let regexp2 = /[^\(\)]/g
        let onlyBracket = noNames.replace(regexp2, '')
        if (onlyBracket % 2 === 1) {
          _g.toastMsg(this, 'error', '存在未闭合的括号！')
          return
        }
        // 递归模式的替换掉所有的括号直到字符串为空
        let circleLen = onlyBracket.length / 2
        for (let i = 0; i < circleLen; i++) {
          onlyBracket = onlyBracket.replace(/\(\)/g, '')
          if (onlyBracket.length === 0) {
            break
          }
        }
        if (onlyBracket.length > 0) {
          _g.toastMsg(this, 'error', '存在未闭合的括号！')
          return
        }
        // 检测是否有无法识别的逻辑名称
        let onlyLogic = noNames.replace(/(\()|(\))/g, '')
        result = onlyLogic.replace(/(AND)|(OR)/g, '')
        if (result.length > 0) {
          _g.toastMsg(this, 'error', '存在未知的逻辑！')
          return
        }
        _g.toastMsg(this, 'success', '格式检查通过！')
      }
    }
  }
</script>
<style scoped>
  .form-tips {
    font-size: 12px;
  }
  .form-tips:before {
    display: inline-block;
    color: #ff4949;
    margin-right: 4px;
    content: '*';
  }
</style>


// WEBPACK FOOTER //
// filterConfig.vue?29f78eda